import { IconProps } from "../../interfaces";

const HelpIcon = ({ width, height, fill }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 797.43 803"
      width={width}
      height={height ?? width}
      fill={fill}
    >
      <defs>
        <style>
          {`.a,.b{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;}
            .a{stroke-width:10px;}
            .b{stroke-width:21px;}
            `}
        </style>
      </defs>
      <path
        className="a"
        d="M753,909V619s3-16-24-35S573,473,573,473s-33-34-4-71,75-2,92,11,56,41,56,41,45-37,100-3c0,0,41,30,44,45"
        transform="translate(-552.07 -116)"
      />
      <path
        className="a"
        d="M717,454s-9-73-28-121-53-121-32-150,67-28,84,7,47,128,47,128V166s2-45,50-45,47,45,47,56V321l46-139s14-47,66-32,18,92,18,92l-30,93,67-67s37-28,70,3-1,74-27,94"
        transform="translate(-552.07 -116)"
      />
      <path
        className="b"
        d="M1292.56,724H1146.28l-46.38,70.48c-17.35,26.37-58.38,13.92-58.16-17.64l.37-52.84H911.44A46.44,46.44,0,0,1,865,677.56V411.44A46.44,46.44,0,0,1,911.44,365h381.12A46.44,46.44,0,0,1,1339,411.44V677.56A46.44,46.44,0,0,1,1292.56,724Z"
        transform="translate(-552.07 -116)"
      />
      <path
        d="M940.49,492.77v37.88h47.26V492.77c0-5.42,1-9.47,3-12.18a9.28,9.28,0,0,1,7.85-4.06,9.61,9.61,0,0,1,8,4q3.06,4,3.06,12.23V597q0,8.2-3.1,12.27a9.59,9.59,0,0,1-8,4,9.23,9.23,0,0,1-7.89-4.1q-3-4.11-3-12.22V552.48H940.49V597q0,8.2-3.1,12.27a9.59,9.59,0,0,1-8,4,9.24,9.24,0,0,1-7.89-4.1q-2.94-4.11-2.95-12.22V492.77c0-5.42,1-9.47,2.91-12.18a9.26,9.26,0,0,1,7.93-4.06,9.61,9.61,0,0,1,8,4Q940.49,484.56,940.49,492.77Z"
        transform="translate(-552.07 -116)"
      />
      <path
        d="M1104.39,499.44h-49.33v32.48h45.42c3.34,0,5.84.91,7.48,2.75a10.43,10.43,0,0,1,2.47,7.26,10.9,10.9,0,0,1-2.43,7.35c-1.62,1.9-4.13,2.84-7.52,2.84h-45.42v37.62h51c3.44,0,6,1,7.78,2.93a11.27,11.27,0,0,1,2.62,7.8,11,11,0,0,1-2.62,7.63c-1.74,1.95-4.34,2.93-7.78,2.93h-59.5q-7.14,0-10.28-3.88c-2.09-2.58-3.13-6.77-3.13-12.54V495.2a26.51,26.51,0,0,1,1.4-9.42,9.87,9.87,0,0,1,4.38-5.33,15.59,15.59,0,0,1,7.63-1.66h57.81c3.49,0,6.08.94,7.78,2.84a10.74,10.74,0,0,1,2.54,7.44,10.88,10.88,0,0,1-2.54,7.53C1110.47,498.5,1107.88,499.44,1104.39,499.44Z"
        transform="translate(-552.07 -116)"
      />
      <path
        d="M1155.34,492.77V589h44.38c3.54,0,6.25,1.05,8.15,3.16a11.42,11.42,0,0,1,2.84,7.93,11.16,11.16,0,0,1-2.81,7.9q-2.79,3-8.18,3h-52.86q-7.15,0-10.29-3.88c-2.09-2.58-3.13-6.77-3.13-12.54V492.77c0-5.42,1-9.47,3-12.18a9.31,9.31,0,0,1,7.86-4.06,9.61,9.61,0,0,1,8,4Q1155.34,484.56,1155.34,492.77Z"
        transform="translate(-552.07 -116)"
      />
      <path
        d="M1267,559.52h-20V597q0,8-3.1,12.17a9.6,9.6,0,0,1-15.77,0q-3-4.11-3-12V495.2q0-8.83,3.32-12.63t10.54-3.78H1267q12.46,0,19.17,2.34a27.31,27.31,0,0,1,11.47,7.49,34.62,34.62,0,0,1,7.33,12.81,54.13,54.13,0,0,1,2.51,17.05q0,20.21-10.17,30.62T1267,559.52Zm-5.3-60.62H1247v40.41h14.75a36.64,36.64,0,0,0,12.94-2,15.35,15.35,0,0,0,7.92-6.5q2.73-4.5,2.73-11.81,0-8.74-4.2-14.25Q1276.4,498.91,1261.73,498.9Z"
        transform="translate(-552.07 -116)"
      />
      <line
        className="a"
        x1="420.84"
        y1="608"
        x2="420.93"
        y2="798"
      />
    </svg>
  );
};

export default HelpIcon;
